// extracted by mini-css-extract-plugin
module.exports = {"breakWordText":"ReviewCard_breakWordText__m205L"};